import { Permissions } from '../../../../models/enums/permissions';
import { AnyInventory } from '../../../../models/enums/permission-groups';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { PageBody, PageContent, PageHeading } from '../../../../components/page-components/_index';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { PageNames, Routes } from '../../../../utils/app-constants';
import { InventorySvc } from '../../../../shared/services/inventory-service';
import { StatusCode } from '../../../../utils/api';
import { cloneDeep } from 'lodash';
import { Table } from '../../../../components/tables/Table';
import { ActionCreateInventoryReport } from '../components/ActionCreateInventoryReport';
import { PhysicalInventoryListItem } from '../../../../modules/inventory/models/physical-inventory-list-item';
import { formatCurrency } from '../../../../utils/currency-formatter';
import "../../../../modules/inventory/styles.scss";
import { NavLink } from 'react-router-dom';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { ClearButton } from '../../../../components/button/ClearButton';
import { InventoryFinalSummaryDocument } from '../../../../modules/inventory/models/inventory-final-summary-document';

export const InventoryPhysicalScene = () => {

    const dispatch = useDispatch();

    const [service] = React.useState(new InventorySvc());
    const [isCreateFlyoutOpen, setIsCreateFlyoutOpen] = React.useState(false);

    const [reports, setReports] = React.useState<PhysicalInventoryListItem[]>([]);


    /**
     * Fetch our data once on page load
     */
    React.useEffect(() => {
        getReports();
    }, []);

    async function getReports() {
        const res = await service.getPhysicalReports();
        if (res.status === StatusCode.Success) {
            const cloned = cloneDeep(res.data);
            setReports(cloned);
        }
    }

    const onCreateClick = () => {
        setIsCreateFlyoutOpen(true);
    };

    const onCreateFlyoutSuccess = () => {
        getReports() 
        setIsCreateFlyoutOpen(false);
    };

    const onCreateFlyoutCancel = () => {
        setIsCreateFlyoutOpen(false);
    };

    const onFinalSummaryClick = (reportId: string) => {
        const req = new InventoryFinalSummaryDocument(reportId);
        dispatch(getDocumentHelper(req));
    }

    const getClassName = (status: string) => {

        var className = "";

        if (status.toUpperCase() === "COMPLETE") {
            className = "complete";
        }
        else if (status.toUpperCase() === "IN PROGRESS") {
            className = "in-progress";
        }
        else if (status.toUpperCase() === "PROCESSING") {
            className = "processing";
        }
        else if (status.toUpperCase() === "ERROR") {
            className = "error";
        }

        return 'inventory-report-status ' + className;
    }

    return <PageContent pageName={PageNames.INVENTORY_PHYSICAL_LIST} classes='inventory-physical'>
        <PageHeading>
            <HasPermission requiredPermissions={[
                    Permissions.InventoryPhysicalCreate
                ]}>
                <button className="btn new attention" onClick={onCreateClick}>
                    CREATE
                </button>
            </HasPermission>
        </PageHeading>
        <PageBody>
            <Table
                header={[
                    'Date',
                    'Name',
                    'Status',
                    'Value',
                    'Downloads'
                ]}
                noResultsMessage="No inventory reports available">
                {
                    reports.map((itm: PhysicalInventoryListItem, idx: number) => {
                        return <tr>
                            <td>
                                <HasPermission requiredPermissions={[
                                    ...AnyInventory
                                ]}>
                                    {
                                        itm.status === "IN PROGRESS" || itm.status === "COMPLETE" ? <NavLink to={Routes.INVENTORY_PHYSICAL_DETAILS.formattify(itm.id)}>
                                            {itm.date}
                                        </NavLink>
                                            : <span>{itm.date}</span>
                                    }
                                </HasPermission>
                            </td>
                            <td><span>{itm.name}</span></td>
                            <td className={getClassName(itm.status)}><span>{itm.status}</span></td>
                            <td>{itm.totalValue === undefined ? <span></span> : <span>{formatCurrency(itm.totalValue)}</span>}</td>
                            <td>
                                <HasPermission requiredPermissions={[
                                    Permissions.InventoryPhysicalView
                                ]}>
                                    {
                                        itm.status === "COMPLETE"
                                            ? <ClearButton
                                                id={'final-summary-' + idx}
                                                text="Final Summary"
                                                classes="action"
                                                onBtnClick={() => onFinalSummaryClick(itm.id)}
                                                icon="la-file-pdf-o" />
                                            : <span></span>
                                    }
                                </HasPermission>
                            </td>
                        </tr>
                    })
                }
            </Table>
            <ActionCreateInventoryReport
                visible={isCreateFlyoutOpen}
                onClose={onCreateFlyoutCancel}
                onSuccess={onCreateFlyoutSuccess}
            />
        </PageBody>        
    </PageContent>;
};
